import { useEffect } from "react";
import { GBR_EMAIL, NETWORK_RAIL_EMAIL } from "../../constants/email.constants";
import {
  CENTRAL_FUNCTIONS,
  CENTRAL_FUNCTIONS_GBRTT,
} from "../../constants/centralFunctions.constants";
import useSharedStore from "../../stores/sharedStore";
import { useCentralFunction } from "../useAPI";

const useInitialiseCentralFunctions = (email) => {
  const [{ data = [], loading: isFetchingCentralFunctions }, fetchLatest] = useCentralFunction("", {
    manual: true,
  });

  const setCentralFunctions = useSharedStore((state) => state.setCentralFunctions);

  useEffect(() => {
    fetchLatest();
  }, []);

  useEffect(() => {
    if (email.includes(NETWORK_RAIL_EMAIL)) {
      setCentralFunctions(CENTRAL_FUNCTIONS);
    } else if (email.includes(GBR_EMAIL)) {
      setCentralFunctions(CENTRAL_FUNCTIONS_GBRTT);
    }
  }, [data]);

  return { isFetchingCentralFunctions };
};

export default useInitialiseCentralFunctions;
